import { API_URL, RAPI_URL } from '../circulusConfig';
import { encodeGetParams, getHeaders } from '../common/util';
import { POST, PATCH } from '../common/consts';

// 200.봇 데이터 목록 가져오기
const getUserBotsAPI = async ({ userId, ...rest }) => {
  const res = await fetch(`${API_URL}bots/${userId}?${encodeGetParams(rest)}`);
  const result = res.json();
  return result;
};

// 201.여러 개의 로봇에 여러 개의 봇 설치
const installBotAPI = async ({ robots, bots }) => {
  const res = await fetch(
    `${API_URL}bots/install`,
    getHeaders(POST, { robots, bots }),
  );
  const result = res.json();
  return result;
};
// 202.여러 개의 로봇에 봇에 대한 사용설정 변경
const updateBotAPI = async ({ robots, bots, use, install }) => {
  const res = await fetch(
    `${API_URL}bots/update`,
    getHeaders(PATCH, { robots, bots, use, install }),
  );
  const result = res.json();
  return result;
};
// 203.여러 개의 로봇에 여러 개의 봇 제거
const uninstallBotAPI = async ({ robots, bots }) => {
  const res = await fetch(
    `${API_URL}bots/uninstall`,
    getHeaders(PATCH, { robots, bots }),
  );
  const result = res.json();
  return result;
};

// 204. 봇 설치/변경/제거 검색을 위한 로봇 데이터 목록 가져오기
const getUserRobotsForBotsAPI = async ({ userId, ...rest }) => {
  const res = await fetch(
    `${API_URL}bots/robots/${userId}?${encodeGetParams(rest)}`,
  );
  const result = res.json();
  return result;
};

const getFile = (data) => {
  const [[key, v]] = Object.entries(data);
  if (
    ['thumb', 'photo', 'subuserPhoto', 'userPhoto', 'icon', 'diary'].indexOf(
      key,
    ) > -1
  ) {
    if (v) {
      return `${RAPI_URL}${key}/${v}`;
    }
  }
  return null;
};

export {
  getUserBotsAPI,
  installBotAPI,
  updateBotAPI,
  uninstallBotAPI,
  getUserRobotsForBotsAPI,
  getFile,
};
